import React, { FC, useMemo } from 'react'

import { List, ListItem, makeStyles, Grid, Typography, Box } from '@material-ui/core'

import formatMatchMinute from 'lib/formatMatchMinute'
import { PlayerProfileResponse } from 'protos'
import Point from 'components/Point'

import { ScoreItemIcon } from '../../../../components'
import { getTimelineEventColor } from '../../lib'

type Props = {
  timeline: PlayerProfileResponse.TimelinePoint[]
}

const useStyles = makeStyles(({ palette, spacing }) => {
  return {
    iconContainer: {
      width: 30,
      height: 30,
      marginRight: spacing(2),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& img': {
        maxWidth: 24,
      },
    },
    title: {
      color: palette.common.white,
      fontSize: 14,
    },
    matchMinute: {
      opacity: .5,
    },
    subtitle: {
      color: palette.common.white,
      fontSize: 12,
      opacity: .5,
    },
    divider: {
      borderColor: '#8EA5C238',
    },
  }
})

const TimelineEvents: FC<Props> = ({ timeline }) => {
  const classes = useStyles()
  const events = useMemo(
    () => [...timeline]
      .filter(({ projection, notInTeam }) => !projection && !notInTeam)
      .flatMap(({ event }) => event)
      .reverse(),
    [timeline],
  )

  return (
    <List disablePadding>
      {(events as PlayerProfileResponse.TimelineEvent[]).map((event, i) => {
        return (
          <ListItem
            key={i}
            divider
            classes={{ divider: classes.divider }}
          >
            <Grid
              item
              className={classes.iconContainer}
            >
              <ScoreItemIcon
                bonus={event.bonus}
                event={event.event?.type}
              />
            </Grid>
            <Grid item xs>
              <Typography
                className={classes.title}
                color="inherit"
              >
                {event.title}
                {' '}
                <span className={classes.matchMinute}>{formatMatchMinute(event.clock)}</span>
              </Typography>
              <Typography
                className={classes.subtitle}
                color="inherit"
              >
                {event.subtitle}
              </Typography>
            </Grid>
            {event.value !== 0 && (
              <Grid item>
                <Box color={getTimelineEventColor(event)}>
                  <Point
                    explicitPlus
                    value={event.value}
                  />
                </Box>
              </Grid>
            )}
          </ListItem>
        )
      })}
    </List>
  )
}

export default TimelineEvents
try {
    // @ts-ignore
    TimelineEvents.displayName = "TimelineEvents";
    // @ts-ignore
    TimelineEvents.__docgenInfo = { "description": "", "displayName": "TimelineEvents", "props": { "timeline": { "defaultValue": null, "description": "", "name": "timeline", "required": true, "type": { "name": "any[]" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/PlayerLayer/components/PlayerProfile/tabs/TimelineTab/components/TimelineEvents/TimelineEvents.tsx#TimelineEvents"] = { docgenInfo: TimelineEvents.__docgenInfo, name: "TimelineEvents", path: "src/components/PlayerLayer/components/PlayerProfile/tabs/TimelineTab/components/TimelineEvents/TimelineEvents.tsx#TimelineEvents" };
}
catch (__react_docgen_typescript_loader_error) { }